<template>
  <v-app id="inspire">
    <router-view />
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=M+PLUS+Rounded+1c:400,800&display=swap&subset=japanese');
</style>

<style>
.main--text {
  font-family: 'M PLUS Rounded 1c', sans-serif;
}

.title--text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
}
a {
  text-decoration: none;
}

.line--feed {
  white-space: pre-line;
}
</style>